import React from 'react';
import Button from 'components/partials/button/button';
import Icons from 'assets/icons';

interface LessonClickArgs {
  to: string;
  id: number;
}

interface LessonNavigationProps {
  lessons: string[];
  currentLessonId: string | number;
  courseId: string | number;
  handleLessonClick: (args: LessonClickArgs) => void;
}

const LessonNavigation = ({
  lessons,
  currentLessonId,
  courseId,
  handleLessonClick,
}: LessonNavigationProps): React.JSX.Element => {
  const currentIndex = lessons.findIndex(
    (id) => id == `lesson-${currentLessonId}`
  );

  const isFirstLesson = currentIndex === 0;
  const isLastLesson = currentIndex === lessons.length - 1;

  const navigateToLesson = (newIndex: number): void => {
    const newLessonId = lessons[newIndex];

    const lessonNumber = Number.parseInt(newLessonId.match(/\d+/)![0], 10);
    const to = `/learn/courses/${courseId}/lesson/${lessonNumber}`;

    handleLessonClick({
      to: to,
      id: lessonNumber,
    });
  };

  return (
    <div className="flex justify-between items-center">
      {isFirstLesson ? (
        <div className="flex-1"></div>
      ) : (
        <Button
          variant="reserve-outlined"
          onClick={() => navigateToLesson(currentIndex - 1)}
          iconBefore={<Icons.DoubleArrow className="rotate-180" aria-hidden="true" />}
        >
          Previous Lesson
        </Button>
      )}
      {!isLastLesson && (
        <Button
          variant="reserve-outlined"
          onClick={() => navigateToLesson(currentIndex + 1)}
          iconAfter={<Icons.DoubleArrow aria-hidden="true" />}
        >
          Next Lesson
        </Button>
      )}
    </div>
  );
};

export default LessonNavigation;
